$(() => {

  function fixMenuWidth() {
    var isFixed = $menu.hasClass('is-fixed');
    if(isFixed){
      $menu.removeClass('is-fixed');
    }
    $list.css({width: 'auto'});
    LIST_WIDTH = $list.width();
    LIST_HEIGHT = $list.height();
    $list.css({width: LIST_WIDTH + 'px'});
    menuOffset = $menu.offset().top;

    if(isFixed){
      $menu.addClass('is-fixed');
    }
  }

  $(document).on('click','.b-service-page__filter-toggle',  (e) => {
    e.preventDefault()
    $('.b-service-page__menu-list').slideToggle();
  });

  if($('.b-service-page').length > 0){
    var $menu = $('.b-service-page__menu');
    var $window = $(window);
    var $list = $('.b-service-page__menu-list');

    var TOP_MARGIN = 20;
    var LIST_WIDTH = 0;
    var LIST_HEIGHT = $list.height();

    var menuOffset = $menu.offset().top;

    fixMenuWidth();
   
    $window.on('scroll', function(e){
      let currentScroll = $window.scrollTop();
      if(currentScroll >= menuOffset - TOP_MARGIN &&
        currentScroll + LIST_HEIGHT < $menu.height() + menuOffset - TOP_MARGIN){
        $menu.addClass('is-fixed');
      } else {
        $menu.removeClass('is-fixed');
      }
    });

    $window.on('resize', function(e){
      fixMenuWidth();
    });
  }
})
